"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("../BaseView");
var Header_vue_1 = __importDefault(require("@/components/header/Header.vue"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var PartnershipParentView = /** @class */ (function (_super) {
    __extends(PartnershipParentView, _super);
    function PartnershipParentView() {
        return _super.call(this) || this;
    }
    PartnershipParentView.prototype.mounted = function () {
        var _this = this;
        this.$getPartnershipDataService.request(this.$route.params.partnershipSlug).then(function (partnership) {
            _this.partnership = partnership;
            if (_this.$route.params.languageIsoCode != undefined && _this.partnership.languages) {
                for (var _i = 0, _a = _this.partnership.languages; _i < _a.length; _i++) {
                    var language = _a[_i];
                    if (language.iso_639_1_code === _this.$route.params.languageIsoCode) {
                        _this.$i18n.locale = _this.$route.params.languageIsoCode;
                        _this.$browserStorage.setCookie('lang', _this.$i18n.locale);
                        break;
                    }
                }
            }
            _this.$browserStorage.setCookie('slug', _this.$route.params.partnershipSlug, 365);
            _this.$root.$emit('PARTNERSHIP_SELECTED');
            _this.setPartnershipMetaInfo();
        }, function (error) {
            _this.$router.push({ name: 'error', params: { code: error.response.status } });
            _this.$browserStorage.removeCookie('slug');
        });
    };
    PartnershipParentView.prototype.setPartnershipMetaInfo = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _l = this.$meta().addApp('partnership-info'), set = _l.set, remove = _l.remove;
        var getTagJson = {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "A new way to explore and discover European Routes EU funded project to promote the discovery of European heritage surrounding European pilgrimage routes",
            "image": [
                parameters_1.default.cdn.host + '/partnership/' + this.partnership.slug + '/header.jpg'
            ],
            "address": {
                "@type": "PostalAddress",
                "streetAddress": this.partnership.street,
                "addressLocality": (_a = this.partnership.country) === null || _a === void 0 ? void 0 : _a.name,
                "addressRegion": (_b = this.partnership.country) === null || _b === void 0 ? void 0 : _b.code,
                "postalCode": this.partnership.postal_code,
                "addressCountry": (_c = this.partnership.country) === null || _c === void 0 ? void 0 : _c.code
            },
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": (_d = this.partnership.country) === null || _d === void 0 ? void 0 : _d.gps_latitude,
                "longitude": (_e = this.partnership.country) === null || _e === void 0 ? void 0 : _e.gps_longitude
            },
            "telephone": "",
            "priceRange": "$$$"
        };
        var metaInfo = {
            meta: [
                { name: 'geo.region', content: (_f = this.partnership.country) === null || _f === void 0 ? void 0 : _f.code },
                { name: 'geo.placename', content: this.partnership.street },
                { name: 'geo.position', content: ((_g = this.partnership.country) === null || _g === void 0 ? void 0 : _g.gps_latitude) + ";" + ((_h = this.partnership.country) === null || _h === void 0 ? void 0 : _h.gps_longitude) },
                { name: 'ICBM', content: ((_j = this.partnership.country) === null || _j === void 0 ? void 0 : _j.gps_latitude) + ", " + ((_k = this.partnership.country) === null || _k === void 0 ? void 0 : _k.gps_longitude) }
            ],
            script: [
                {
                    json: getTagJson,
                    type: 'application/ld+json'
                }
            ],
            link: []
        };
        for (var _i = 0, _m = this.partnership.languages; _i < _m.length; _i++) {
            var language = _m[_i];
            if (metaInfo.link && language.iso_639_1_code !== this.$i18n.locale) {
                var params = this.$route.params;
                params.languageIsoCode = language.iso_639_1_code;
                metaInfo.link.push({
                    rel: 'alternate',
                    hreflang: language.iso_639_1_code,
                    href: parameters_1.default.host + this.$router.resolve({ name: this.$route.name, params: params }).route.path
                });
            }
        }
        remove();
        set(metaInfo);
    };
    __decorate([
        vue_property_decorator_1.Watch('$route')
    ], PartnershipParentView.prototype, "setPartnershipMetaInfo", null);
    PartnershipParentView = __decorate([
        vue_property_decorator_1.Component({
            name: 'PartnershipParentView',
            components: {
                Header: Header_vue_1.default
            }
        })
    ], PartnershipParentView);
    return PartnershipParentView;
}(BaseView_1.BaseView));
exports.default = PartnershipParentView;
